import axios from "axios";
import { collection, getDocs, query, where } from "firebase/firestore";
import db from "../config/firebase";

// const roomsList = [

//     {
//         id: 1,
//         level: 1,
//         code: '001',
//         details: 'TV + Aire acondicionado',
//         type: 'double-bed',
//         status: 'open'
//     },
//     {
//         id: 2,
//         level: 1,
//         code: '002',
//         details: 'TV + Aire acondicionado + Jacuzzi',
//         type: 'double',
//         status: 'close'
//     },
//     {
//         id: 3,
//         level: 1,
//         code: '003',
//         details: 'TV + Aire acondicionado',
//         type: 'personal',
//         status: 'clean'
//     },
//     {
//         id: 4,
//         level: 2,
//         code: '004',
//         details: 'TV + Aire acondicionado + Jacuzzi + Nevera',
//         type: 'junior-suite',
//         status: 'close'
//     },
//     {
//         id: 5,
//         level: 2,
//         code: '005',
//         details: 'TV + Aire acondicionado',
//         type: 'personal',
//         status: 'open'
//     },
//     {
//         id: 6,
//         level: 2,
//         code: '006',
//         details: 'TV + Aire acondicionado + Nevera',
//         type: 'double-bed',
//         status: 'open'
//     },
//     {
//         id: 7,
//         level: 3,
//         code: '007',
//         details: 'TV + Aire acondicionado + Jacuzzi',
//         type: 'junior-suite',
//         status: 'close'
//     },
//     {
//         id: 8,
//         level: 3,
//         code: '008',
//         details: 'TV + Aire acondicionado + Acceso a la piscina',
//         type: 'double',
//         status: 'clean'
//     },
//     {
//         id: 9,
//         level: 3,
//         code: '009',
//         details: 'TV + Aire acondicionado',
//         type: 'personal',
//         status: 'open'
//     },
//     {
//         id: 10,
//         level: 3,
//         code: '010',
//         details: 'TV + Aire acondicionado + Jacuzzi + Acceso a la piscina + Desayuno',
//         type: 'suite',
//         status: 'clean'
//     },

// ]

export const getRoomsList = async () => {
  const q = query(collection(db, "room"));

  const querySnapshot = await getDocs(q);
  let roomsArray = [];
  querySnapshot.forEach((doc) => {
    roomsArray.push(doc.data());
  });

  return roomsArray;
};

// filters
export const allRooms = async (levelValue) => {
  try {
    const q = query(collection(db, "room"));

    const querySnapshot = await getDocs(q);
    let roomList = [];
    querySnapshot.forEach((doc) => {
      roomList.push(doc.data());
    });
    if (levelValue !== "all") {
      const allRoom = roomList.filter((item) => item.level == levelValue);
      return allRoom;
    } else {
      return roomList;
    }

    return false;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const opens = async (levelValue) => {
  try {
    const q = query(collection(db, "room"));
    const querySnapshot = await getDocs(q);
    let openArray = [];
    querySnapshot.forEach((doc) => {
      openArray.push(doc.data());
    });
    // response - object, eg { status: 200, message: 'OK' }
    if (levelValue !== "all") {
      const openRooms = openArray.filter(
        (item) => item.status == "open" && item.level == levelValue
      );
      return openRooms;
    } else {
      const openRooms = openArray.filter((item) => item.status == "open");
      return openRooms;
    }

    return false;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const closes = async (levelValue) => {
  try {
    const q = query(collection(db, "room"));
    const querySnapshot = await getDocs(q);
    let closeArray = [];
    querySnapshot.forEach((doc) => {
      closeArray.push(doc.data());
    });
    // response - object, eg { status: 200, message: 'OK' }
    if (levelValue !== "all") {
      const closeRooms = closeArray.filter(
        (item) => item.status == "close" && item.level == levelValue
      );
      return closeRooms;
    } else {
      const closeRooms = closeArray.filter(
        (item) => item.status == "close"
      );
      return closeRooms;
    }

    return false;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const cleans = async (levelValue) => {
  try {
    const q = query(collection(db, "room"));
    const querySnapshot = await getDocs(q);
    let cleanArray = [];
    querySnapshot.forEach((doc) => {
      cleanArray.push(doc.data());
    });
    // response - object, eg { status: 200, message: 'OK' }
    if (levelValue !== "all") {
      const cleanRooms = cleanArray.filter(
        (item) => item.status == "cleaning" && item.level == levelValue
      );
      return cleanRooms;
    } else {
      const cleanRooms = cleanArray.filter(
        (item) => item.status == "cleaning"
      );
      return cleanRooms;
    }

    return false;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const levelCheckoutFilter = (levelValue, type) => {
  let roomsList = [];

  roomsList = getRoomsList();

  if (type !== "all" && levelValue !== 0) {
    return roomsList.filter(
      (item) =>
        item.status == "close" && item.level == levelValue && item.type == type
    );
  } else {
    if (levelValue !== 0) {
      return roomsList.filter(
        (item) => item.status == "close" && item.level == levelValue
      );
    } else {
      return type !== "all"
        ? roomsList.filter(
            (item) => item.status == "close" && item.type == type
          )
        : roomsList.filter((item) => item.status == "close");
    }
  }
};

export const roomTypeFilter = (levelValue, type) => {
  let roomsList = [];

  roomsList = getRoomsList();

  if (type !== "all" && levelValue !== 0) {
    return roomsList.filter(
      (item) =>
        item.status == "close" && item.level == levelValue && item.type == type
    );
  } else {
    if (levelValue !== 0) {
      return roomsList.filter(
        (item) => item.status == "close" && item.level == levelValue
      );
    } else {
      return type !== "all"
        ? roomsList.filter(
            (item) => item.status == "close" && item.type == type
          )
        : roomsList.filter((item) => item.status == "close");
    }
  }
};

export const level = async (value, roomType) => {
  if (roomType == "open") {
    return opens(value);
  } else if (roomType == "close") {
    return closes(value);
  } else if (roomType == "cleaning") {
    return cleans(value);
  } else if (roomType == "all") {
    return allRooms(value);
  }
};

export default getRoomsList;
